import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
import MyBookmarks from '@/views/MyBookmarks.vue';
import MyTables from '@/views/MyTables.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/table_detail/:cluster/:database/:schema/:name',
      redirect({ params }) {
        // ! Redirect to keep old links compatible.
        return {
          path: '/', query: {
            selectedTreeItem: `${params.cluster}.${params.database}.${params.schema}.${params.name}`
          }
        };
      }
    },
    {
      path: '/myBookmarks',
      name: 'myBookmarks',
      component: MyBookmarks
    },
    {
      path: '/myDatasets',
      name: 'myDatasets',
      component: MyTables
    },
    {
      path: '/myTables',
      redirect: '/myDatasets'
    }
  ]
});
